export default EsqueciSenhaController;

/** @ngInject */
function EsqueciSenhaController(Usuario, $state) {
  var vm = this;

  vm.usuario = {};
  vm.esqueciMinhaSenha = esqueciMinhaSenha;

  function esqueciMinhaSenha() {
    Usuario
      .esqueciMinhaSenha(vm.usuario)
      .then((msg) => Usuario.dialog('', msg))
      .then(() => $state.go('consulta.usuario.login'));
  }
}



/** WEBPACK FOOTER **
 ** ./pages/consulta/usuario/esqueci-senha.controller.ts
 **/